<template>
  <v-container grid-list-sm text-xs-left>
    <v-layout wrap row>
      <v-btn
          icon
          @click="navigate('*goBack*')"
      >
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-flex class="py-2 headline">
        Challenge Details
      </v-flex>
      <v-flex xs12 class="px-4 subheading">
        <span v-if="newFlag" class="subheading">Here you can create a challenge</span>
        <span v-else class="subheading">Here you can update a challenge</span>
      </v-flex>
    </v-layout>
    <v-form ref="form">
      <v-layout row wrap pa-2>

        <v-flex xs12 pa-3>
          <v-textarea
              v-model="challenge.Title"
              name="Title"
              label="Insert here the title"
              :rules="rules.title"
              :counter="200"
              border-radius="20px"
              rows="1"
              box
              auto-grow
              class="subheading"
              @blur="sanitize($event,'Title')"
          />
        </v-flex>

        <v-flex xs12 pa-3>
          <DescriptionCreator
              :contentProp="challenge.Description"
              @onTextWritten="textDescription"
          >
          </DescriptionCreator>
        </v-flex>
        <v-flex xs12 px-3 pt-3 pb-2>
          <v-combobox
              v-model="challenge.tags"
              label="Insert here tags (press enter after each tag)"
              chips
              clearable
              multiple
              :rules="rules.tags"
              append-icon
              box
          >
            <template v-slot:selection="tag">
              <v-chip
                  :selected="tag.selected"
                  close
                  dark
                  color="primary"
                  @input="removeEntity(tag.item)"
              >
                <strong>{{ tag.item }}</strong>&nbsp;
              </v-chip>
            </template>
          </v-combobox>
        </v-flex>

        <v-flex py-0 class="text-xs-center">
          <v-btn flat v-if="this.challenge.tags.length" round dark color="blue" @click="openStartupsList">
            Startups to be notified
          </v-btn>
        </v-flex>
        <v-dialog
            v-model="startupsList"
            transition="dialog-bottom-transition"
            width="fit-content"
        >

          <v-card style="width: 500px">
            <v-card-title class="headline">
              Notified Startups
              <v-spacer></v-spacer>
              <v-btn round color="blue" class="white--text font-weight-bold" @click="reset">
                Reset
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn icon @click="startupsList = false" >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>

            <v-card-text>
              <p class="text-xs-center font-weight-bold"> Filters </p>
              <v-card-actions>
                <v-switch class="switch"
                          v-model="enableCountry"
                          label="Country"
                          hide-details
                          inset
                />
                <v-autocomplete class="select"
                                v-model="selectedCountry"
                                :items="countries"
                                :menu-props="{ offsetY: true }"
                                required
                                label="Select country"
                                item-text="country"
                                item-value="country"
                                return-object
                                multiple
                                v-if="enableCountry"
                                variant="outlined"

                >
                  <template v-slot:prepend-item>
                    <v-list-tile
                        ripple
                        @click="selectAllCountry"
                    >
                      <v-list-tile-action>
                        <v-checkbox v-model="selectedAllCountry"
                        >
                        </v-checkbox>
                      </v-list-tile-action>
                      <v-list-tile-content style="font-weight: bold">
                        <template v-if="selectedAllCountry" >
                          Deselect all
                        </template>
                        <template v-else>
                          Select all
                        </template>
                      </v-list-tile-content>
                    </v-list-tile>
                  </template>
                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index <= 1" class="ma-2">
                      {{ item }}
                    </v-chip>
                    <span v-else-if="index === 2" class="ma-2">
        +{{ selectedCountry.length - 2 }} more
      </span>
                  </template>
                </v-autocomplete>

              </v-card-actions>
              <v-card-actions>
                <v-switch class="switch"
                          v-model="enableMarket"
                          label="Market"
                          hide-details
                          inset
                />
                <v-select class="select"
                          v-model="selectedMarket"
                          :items="Object.values(markets)"
                          label="Select market"
                          :menu-props="{ offsetY: true }"
                          required
                          item-text="market"
                          item-value="market"
                          return-object
                          multiple
                          v-if="enableMarket"
                >
                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index <= 1" class="ma-2">
                      {{ item }}
                    </v-chip>
                    <span v-else-if="index === 2" class="ma-2">
        +{{ selectedMarket.length - 2 }} more
      </span>
                  </template>
                </v-select>
              </v-card-actions>

              <v-card-actions>
                <v-switch class="switch"
                          v-model="enableTech"
                          label="Technology Area"
                          hide-details
                          inset
                />
                <v-select class="select"
                          v-model="selectedTech"
                          :items="technologies"
                          :menu-props="{ offsetY: true }"
                          required
                          label="Select technology area"
                          item-text="tech"
                          item-value="tech"
                          return-object
                          multiple
                          v-if="enableTech"
                >

                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index <= 1" class="ma-2">
                      {{ item }}
                    </v-chip>
                    <span v-else-if="index === 2" class="ma-2">
        +{{ selectedTech.length - 2 }} more
      </span>
                  </template>
                </v-select>
              </v-card-actions>
            </v-card-text>
            <v-card-text>
              <v-row align="center" justify="space-between">
                <v-col cols="auto">
                  <p class="text-xs-center font-weight-bold"> Startup to notify </p>
                </v-col>
                <v-col cols="auto">
                  <v-btn
                      color="blue"
                      @click="exportChallengeStartup"
                  >
                    <v-icon left>mdi-download</v-icon>
                    Export Startups
                  </v-btn>
                </v-col>
              </v-row>
              <v-list v-if="startupToContact && startupToContact.length">
                <template v-for="(item, index) in startupToContact">
                  <v-list-tile >
                    {{ item.name }}
                    <v-spacer></v-spacer>
                    <v-btn icon small @click="removeItem(index)">
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </v-list-tile>
                  <v-divider v-if="index < startupToContact.length - 1"></v-divider>
                </template>
              </v-list>
              <div v-else class="text-xs-center">
                There are no startups related to the tags entered
              </div>

              <v-flex v-if="startupToContactRemoved && startupToContactRemoved.length">
                <divider></divider>
                <divider></divider>
                <p class="text-xs-center font-weight-bold"> Startup removed </p>
                <divider></divider>
                <v-list >
                  <template v-for="(item, index) in startupToContactRemoved">
                    <v-list-tile>
                      {{ item.name }}
                      <v-spacer></v-spacer>
                      <v-btn icon small @click="restoreItem(index)">
                        <v-icon>mdi-restore</v-icon>
                      </v-btn>
                    </v-list-tile>
                    <v-divider v-if="index < startupToContact.length - 1"></v-divider>
                  </template>
                </v-list>
              </v-flex>



            </v-card-text>
          </v-card>
        </v-dialog>

        <v-flex xs12 pa-3 v-if="challenge.published">
          <v-textarea
              v-model="challenge.datePublished"
              name="Publication Date"
              label="Publication Date (YYYY-MM-DD)"
              border-radius="20px"
              hide-details
              rows="1"
              box
              prepend-inner-icon="event"
              auto-grow
              readonly
              class="subheading"
          />
        </v-flex>
        <v-flex xs12 pa-3>
          <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              :nudge-right="40"
              :return-value.sync="challenge.date"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              max-width="290px"
              min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                  v-model="challenge.date"
                  label="Deadline (YYYY-MM-DD)"
                  prepend-inner-icon="event"
                  readonly
                  hide-details
                  v-on="on"
                  box
              ></v-text-field>
            </template>
            <v-date-picker
                v-model="challenge.date"
                scrollable
            >
              <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
              <!--<v-btn flat color="primary" @click="$refs.menu.save(challenge.date)">OK</v-btn>-->
              <v-btn flat color="primary" @click="checkDate(challenge.date)">OK</v-btn>
            </v-date-picker>
          </v-menu>
        </v-flex>

        <v-flex xs12 pa-3>
          <v-textarea
              v-model="challenge.reward"
              name="Reward"
              label="Insert here the expected reward"
              :rules="rules.reward"
              :counter="200"
              border-radius="20px"
              rows="1"
              box
              auto-grow
              class="subheading"
              @blur="sanitize($event,'reward')"
          />
        </v-flex>

        <v-flex xs12 pa-3>
          <FileInputChallenge
              ref="fileInputChallenge"
              label="Upload an image (max 5 MB)"
              accept=".jpg,.jpeg,.png"
              :sourceImg="challenge.imgBase64"
              required
              @update="imgUploaded"
          />
          <v-img
              :src="challenge.imgBase64"
              max-height="200px"
              contain
          ></v-img>
        </v-flex>



        <v-flex xs12 pa-3>
          <v-btn v-if="newFlag" round dark color="blue" @click="update()">
            Create
          </v-btn>

          <v-btn v-if="!newFlag" round dark color="blue" @click="update()">
            Update
          </v-btn>
          <v-btn v-if="!newFlag && !challenge.published" round dark color="green" @click="publish()">
            Publish
          </v-btn>
          <v-btn v-if="!newFlag && challenge.published" round dark color="green" @click="publish()">
            Unpublish
          </v-btn>
        </v-flex>

        <v-snackbar
            v-model="snackbar"
            :timeout="timeout"
            color="error"
            top
        >
          {{snackbarText}}
          <v-btn
              color="white"
              flat
              @click="snackbar = false"
          >
            Close
          </v-btn>
        </v-snackbar>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
import RouterService from "@/helpers/RouterService";
import APILoaderDecoratorService from "@/helpers/APILoaderDecoratorService";
import TimeService from "@/helpers/TimeService";
import UrlsService from "@/helpers/UrlsService";
import FileInputChallenge from "@/components/Inputs/FileInputChallenge";
import DescriptionCreator from "@/pages/Admin/Innovation/ChallengeManagement/DescriptionCreator";
import {mapGetters, mapState} from "vuex";
import {values} from "@/utils/values";
import router from "@/routes/router";
import _ from "lodash";
import countryList from "country-list";
import ExcelJS from 'exceljs';
import FileSaver from 'file-saver';

export default {
  name: "ChallengeDetails",
  components: {DescriptionCreator, FileInputChallenge,},
  props: {
    _id: String,
    newFlagProp: Boolean,
  },
  computed: {
    ...mapState({}),
    ...mapGetters("UserState", {
      user: "getUserInfo",
    }),
    items () {
      return [
        {
          name: 'Startups',
          children: this.startups
        }
      ]
    },
    selected () {
      if (!this.active.length) return undefined

      const id = this.active[0]

      return this.startups.find(startup => startup.id === id)
    },
  },
  data() {
    return {
      enableMarket: false,
      selectedMarket: [],
      markets: [],

      enableCountry: false,
      selectedAllCountry: false,
      selectedCountry: [],
      countries: [],

      enableTech: false,
      selectedTech: [],
      technologies: values.techAreas,

      startupsList: false,
      startupToContact: [],
      startupToContactRemoved: [],
      challengeStartup: [],
      unsavedAlert: "You have unsaved changes. Are you sure you wish to leave?",
      rules: {
        title: [v => v.length <= 200 || 'Title must be less than 200 characters'],
        reward: [
          v => v.length <= 200 || 'Reward must be less than 200 characters',value => {
            const pattern = /[^\w."%!;\\\/àèéìòù$£€*?§@ç°()_:|=&^+#',\s -]+/gm;
            if (value.includes('\n')) {
              return 'New lines are not allowed';
            }
            return value === '' || value === '-' || !pattern.test(value) || 'No special characters are allowed'}
        ],
        tags: [value => {
          const pattern = /[^\w.,;'\/àèéìòù -]+/gm
          return value === '' || value === '-' || !pattern.test(value) || 'No special characters are allowed'}],

      },
      // default values for challenge - if the user doesn't insert a value, there will be no problem
      // if the object challenge change, change this default object too
      // the name of the variable has to be equal to name in MongoDB
      // remember to map this object in the searchStartupByChallenge function too
      challenge: {
        Title: "",
        Description: "",
        imgBase64: values.placeholderImgBase64,
        tags: [],
        date: new Date().toISOString().substr(0, 10),
        datePublished: new Date().toISOString().substr(0, 10),
        reward: "",
        published: false,
        createdBy: "",
        startupToContact: [],
        startupsContacted: [],
        startupsRegistered: [],
        filterCountry: [],
        filterMarket: [],
        filterTech: [],
      },
      challengeInit: {
        Title: "",
        Description: "",
        imgBase64: values.placeholderImgBase64,
        tags: [],
        date: new Date().toISOString().substr(0, 10),
        datePublished: new Date().toISOString().substr(0, 10),
        reward: "",
        published: false,
        createdBy: "",
        startupsContacted: [],
        startupsRegistered: [],
        filterCountry: [],
        filterMarket: [],
        filterTech: [],
      },
      tagsOld: [],
      menu: false,
      snackbar: false,
      snackbarText: "",
      timeout: 6000,
      newFlag: this.newFlagProp,

      active: [],
      open: [],
      startups: [],
      saved: true,
      flagInit: [false,false,false,false,false,false,false], //flag necessari per non resettare con i watcher i valori ottenuti leggendo dal db la prima volta
    }
  },
  created() {
    this.getMarkets();
    this.countries = countryList.getNames().sort();
    if(this._id !== "newChallenge"){
      this.newFlag = false
      //this.getChallenge();
    }
    else{
      this.newFlag = true
    }

  },

  mounted() {
    if (this.newFlag) {
      //usato per il caricamento della pagina o per la chiusura
      window.addEventListener("beforeunload",(e) => this.loadPage(e));
      // usato per tutti gli altri click
      router.beforeEach((to,from,next) => {
        if (!this.saved) {
          if (window.confirm(this.unsavedAlert)) {
            this.saved = true
            next()
          }
        } else {
          next()
        }
      });

      /*this.selectedCountry = this.countries;
      this.selectedMarket = this.markets;
      this.selectedTech = this.technologies;*/
    }

    /*if (this.newFlag) {
      this.selectedCountry = this.countries;
      this.selectedMarket = this.markets;
      this.selectedTech = this.technologies;
    }*/

    if (!_.isEqual(this.selectedCountry,this.countries)) {
      this.selectedAllCountry = false;
    }
    else {
      this.enableCountry = false;
    }
  },

  destroyed() {
    if (this.newFlag) {
      window.removeEventListener('beforeunload', (e) => this.loadPage(e));
    }
  },

  watch: {

    "challenge.tags": {
      handler: function (value, oldValue) {

        if (this.flagInit[0]) {
          this.flagInit[0] = false;
        }else {
          if (value !== oldValue) {

            this.getStartupToContactByChallenge();
          }
        }
      }
    },
    selectedCountry: {
      handler: function (value, oldValue) {
        if (this.flagInit[1]) {
          this.flagInit[1] = false;
        }else {
          if (value !== oldValue) {

            this.getStartupToContactByChallenge();
          }
        }
        this.selectedAllCountry = value === this.countries;
      }
    },
    selectedMarket: {
      handler: function (value, oldValue) {
        if (this.flagInit[2]) {
          this.flagInit[2] = false;
        }else {
          if (value !== oldValue) {

            this.getStartupToContactByChallenge();
          }
        }

      }
    },
    selectedTech: {
      handler: function (value, oldValue) {
        if (this.flagInit[3]) {
          this.flagInit[3] = false;
        }else {
          if (value !== oldValue) {

            this.getStartupToContactByChallenge();
          }
        }

      }
    },
    challenge: {
      handler() {
        this.saved = !(this.newFlag && !_.isEqual(this.challenge, this.challengeInit));
      }, deep: true
    },

    enableCountry: {
      handler() {
        if (this.flagInit[4]) {
          this.flagInit[4] = false;
        }
        else {
          this.getStartupToContactByChallenge();
        }
      }
    },
    enableMarket: {
      handler() {
        if (this.flagInit[5]) {
          this.flagInit[5] = false;
        }
        else {
          this.getStartupToContactByChallenge();
        }
      }
    },
    enableTech: {
      handler() {
        if (this.flagInit[6]) {
          this.flagInit[6] = false;
        }
        else {
          this.getStartupToContactByChallenge();
        }
      }
    },

  },
  methods: {

    exportChallengeStartup() {
      let workbook = new ExcelJS.Workbook();
      let sheet = workbook.addWorksheet('Startups');
      let columns = [];
      columns.push({header: "Startup Name", key: "name", width: 25});
      columns.push({header: "Email Address", key: "contactDetails", width: 25});
      columns.push({header: "Contact name", key: "contactName", width: 25});
      columns.push({header: "Mobile phone", key: "mobilePhone", width: 25});
      columns.push({header: "Country", key: "country", width: 25});
      columns.push({header: "Technology area", key: "techArea", width: 25});
      columns.push({header: "Idea state", key: "ideaState", width: 25});
      columns.push({header: "SDK/API", key: "sdkApi", width: 25});
      columns.push({header: "Website", key: "website", width: 25});
      columns.push({header: "Addressed Market", key: "addressedMarket", width: 25});
      columns.push({header: "Agreement", key: "agreement", width: 25});
      columns.push({header: "OpCo", key: "opCo", width: 25});
      columns.push({header: "Link to folder in Peers", key: "linkPeers", width: 60});
      //columns.push({header: "Idea description-IT", key: "descriptionIt", width: 60});

      sheet.columns = columns;

      if (this.startupToContact && this.startupToContact.length > 0) {
        this.startupToContact.forEach((startup) => {
          sheet.addRow({
            name: startup.name || "N/A", // Evita undefined o null
            contactDetails: startup.contactDetails || "N/A",
            contactName: startup.contactName || "N/A",
            mobilePhone: startup.mobilePhone || "N/A",
            country: startup.country || "N/A",
            techArea: startup.techArea || "N/A",
            ideaState: startup.ideaState || "N/A",
            sdkApi: startup.sdkApi || "N/A",
            website: startup.website || "N/A",
            agreement: startup.agreement || "N/A",
            opCo: startup.opCo || "N/A",
            linkPeers: startup.linkPeers || "N/A",
            addressedMarket: startup.addressedMarket || "N/A",
            //descriptionIt: startup.descriptionIt || "N/A",
          });
        });
      }

      sheet.getRow(1).font = { size: 12, bold: true, color: { argb: 'FFFFFFFF' } };
      sheet.getRow(1).eachCell((cell) => {
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FF4169E1' },
          bgColor: { argb: 'FF4169E1' },
        };
      });

      sheet.eachRow({ includeEmpty: true }, (row) => {
        row.eachCell((cell) => {
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
          cell.alignment = { wrapText: true };
        });
      });

      workbook.xlsx.writeBuffer()
          .then((buffer) => {
            FileSaver.saveAs(new Blob([buffer]), `StartupsToNotify.xlsx`);
          })
          .catch((err) => console.log('Error writing excel export', err));
    },

    reset() {
      this.enableCountry = false;
      this.enableMarket = false;
      this.enableTech = false;

      this.getStartupToContactByChallenge();

    },

    getMarkets() {
      let requestUrl = {
        url: UrlsService.getTagsSuggestion,
        timeout: TimeService.secondsToMillis(0),
      };
      let requestData = {
        interactionData: {
          text: "",
          elasticSearchRequest: {
            pageSize: 1000,
            pageNumber: 0
          }
        },
      };
      let requestObject = {
        type: "normal",
        urlsInfo: requestUrl,
        data: {
          data: requestData,
        },
      };
      let messages = {
        title: "List get Markets ",
        error: "Error get Markets...",
      };
      let options = {
        loadingType: "fullscreen",
        timeout: TimeService.secondsToMillis(0),
      };
      APILoaderDecoratorService.setLoader(requestObject, messages, options)
          .then(responseSuccess => {

            let responseMarket = responseSuccess.response.markets;
            if (responseMarket !== undefined) {
              for (let i = 0; i < responseMarket.length; i++) {
                this.markets[i] = responseMarket[i].value
              }
            }
            console.log("markets: ",this.markets);
            if(this._id !== "newChallenge"){
              this.getChallenge();
            }
          });
    },

    selectAllCountry() {
      if (_.isEqual(this.selectedCountry,this.countries)) {
        this.selectedCountry = [];
        this.selectedAllCountry = false;
      } else {
        this.selectedCountry = this.countries;
        this.selectedAllCountry = true;
      }
    },



    removeItem(index) {
      //console.log(this.startupToContactRemoved);
      this.startupToContactRemoved.push(this.startupToContact[index]);
      this.startupToContact.splice(index, 1);
    },

    restoreItem(index) {
      this.startupToContact.push(this.startupToContactRemoved[index]);
      this.startupToContactRemoved.splice(index, 1);
    },

    openStartupsList() {
      if (this.challenge.tags.length) {
        //console.log("startup to contact: ",this.startupToContact);
        this.startupsList = true;
      }
    },

    loadPage(e) {
      let message = "";
      if (!this.saved) {
        e.preventDefault()
        message = "You have unsaved changes. Are you sure you wish to leave?"
        console.log(e);
        e.returnValue = message
      }
      return message
    },
    sanitizeTags(){
      for(let i=0; i<this.challenge.tags.length; i++){
        this.challenge.tags[i] = this.$sanitize(this.challenge.tags[i]);
        if(this.challenge.tags[i].replace(/ /g, "").length === 0) this.challenge.tags.splice(i,1);
        this.challenge.tags[i] = this.challenge.tags[i].trim()
      }
    },
    sanitize(event,variableName) {
      event.preventDefault();
      this["challenge"][variableName] = this.$sanitize(event.target.value)
    },
    isMobile() {
      return this.$vuetify.breakpoint.name === "xs";
    },
    navigate(path) {
      if (!this.saved) {
        if (window.confirm(this.unsavedAlert)) {
          this.saved = true;
          RouterService.goTo(path);
        }
      }
      else {
        RouterService.goTo(path);
      }
    },
    async getChallenge(){
      let requestUrl = {
        url: UrlsService.challengeOperation,
        timeout: TimeService.secondsToMillis(0),
      };
      let requestData = {
        interactionData: {
          text: "GET_BY_ID",
          challengeRequest: {
            challenge: {
              _id: this._id,
            }
          },
        }
      };
      let requestObject = {
        type: "normal",
        urlsInfo: requestUrl,
        data: {
          data: requestData,
        },
      };
      let messages = {
        title: "Challenge",
        loading: "Waiting for challenge...",
        error: "Cannot get challenge...",
      };
      let options = {
        loadingType: "fullscreen",
        timeout: TimeService.secondsToMillis(0),
      };
      await APILoaderDecoratorService.setLoader(requestObject, messages, options)
          .then(responseSuccess => {
            this.flagInit = [true,true,true,true,true,true,true],

                this.challenge = responseSuccess.response.challenges[0];
            for(let i = 0, len = this.challenge.tags.length; i < len; i++)
              this.tagsOld.push(this.challenge.tags[i])
            this.startupToContact = this.challenge.startupToContact;
            this.startupToContactRemoved = this.challenge.startupToContactRemoved;
            this.selectedCountry = this.challenge.filterCountry ? this.challenge.filterCountry : [];
            this.selectedMarket = this.challenge.filterMarket ? this.challenge.filterMarket : [];

            this.selectedTech = this.challenge.filterTech ? this.challenge.filterTech : [];

            this.enableCountry = JSON.stringify(this.selectedCountry) !== JSON.stringify(this.countries)// && this.selectedCountry.length>0;
            this.enableMarket = !_.isEqual(this.selectedMarket,this.markets)// && this.selectedMarket.length>0;
            this.enableTech = JSON.stringify(this.selectedTech) !== JSON.stringify(this.technologies)// && this.selectedTech.length>0;

            if (JSON.stringify(this.selectedCountry) === JSON.stringify(this.countries)) {
              this.selectedCountry = []
            }

            if (_.isEqual(this.selectedMarket,this.markets)) {
              this.selectedMarket = []
            }
            if (JSON.stringify(this.selectedTech) === JSON.stringify(this.technologies)) {
              this.selectedTech = []
            }

            if (!this.enableCountry) {
              this.flagInit[4] = false;
            }
            if (!this.enableMarket) {
              this.flagInit[5] = false;
            }
            if (!this.enableTech) {
              this.flagInit[6] = false;
            }

          });
    },
    removeEntity(item) {
      this.challenge.tags.splice(this.challenge.tags.indexOf(item), 1);
      this.challenge.tags = [...this.challenge.tags,];
    },


    update(){

      let check = this.checkChallenge()
      this.sanitizeTags();

      if(check ==='errorForm'){
        this.snackbar = true
        this.snackbarText = "There's an error in a field!"
      }
      else if(!this.challenge.published && this.challenge.Title === ""){
        this.snackbar = true
        this.snackbarText = "Insert the title"
      }
      else if(this.challenge.published && (check === "errorTitle" || check === "errorDescription" || check === "errorLenght" || check === "errorReward" || check === "errorImgBase64")){
        this.snackbar = true
        this.snackbarText = "Fill in all fields correctly"
      }
      else if(this.challenge.published && check === "errorDate") {
        this.snackbar = true
        this.snackbarText = "Deadline can't be placed in the past."
      }
      else{
        this.challenge["createdBy"] = this.user.email

        this.challenge["startupToContact"] = this.startupToContact
        this.challenge["startupToContactRemoved"] = this.startupToContactRemoved
        this.challenge["filterCountry"] = this.enableCountry ? this.selectedCountry : this.countries
        this.challenge["filterMarket"] = this.enableMarket ? this.selectedMarket : this.markets
        this.challenge["filterTech"] = this.enableTech ? this.selectedTech  : this.technologies
        //this.challenge["filterCountry"] = this.selectedCountry
        //this.challenge["filterMarket"] = this.selectedMarket
        //this.challenge["filterTech"] = this.selectedTech

        let requestUrl = {
          url: UrlsService.challengeOperation,
          timeout: TimeService.secondsToMillis(0),
        };
        let requestData = {
          interactionData: {
            text: this.newFlag ? "CREATE" : "UPDATE",
            challengeRequest: {
              challenge: this.challenge
            }
          },
        };
        let requestObject = {
          type: "normal",
          urlsInfo: requestUrl,
          data: {
            data: requestData,
          },
        };
        let messages = {
          title: "Challenge",
          loading: "Waiting for challenge update...",
          error: "Cannot get challenge update...",
        };
        let options = {
          loadingType: "fullscreen",
          timeout: TimeService.secondsToMillis(0),
        };
        APILoaderDecoratorService.setLoader(requestObject, messages, options)
            .then(responseSuccess => {
              if(this.challenge.published && !(this.challenge.tags.every(item => this.tagsOld.includes(item)) && this.tagsOld.every(item => this.challenge.tags.includes(item))) ){
                this.searchStartupByChallenge();
              }
              if (this.newFlag) {
                console.log("create")
                this.saved = true;
              }
              this.navigate('*goBack*');
            });

      }
    },
    publish(){
      let check = this.checkChallenge()
      this.sanitizeTags();


      if(check === "errorTitle" || check === "errorDescription" || check === "errorLenght" || check === "errorReward" || check === "errorImgBase64"){
        this.snackbar = true
        this.snackbarText = "Fill in all fields correctly"
      }
      else if(check === "errorDate"){
        this.snackbar = true
        this.snackbarText = "Deadline can't be placed in the past."
      }
      else{

        if(this.challenge.published){
          this.challenge.startupsContacted = []
        }

        //change publication date for new pubblication
        this.challenge.datePublished = new Date().toISOString().substr(0, 10);

        //change flag published
        this.challenge.published = !this.challenge.published

        let requestUrl = {
          url: UrlsService.challengeOperation,
          timeout: TimeService.secondsToMillis(0),
        };
        let requestData = {
          interactionData: {
            text: this.newFlag ? "CREATE" : "UPDATE",
            challengeRequest: {
              challenge: this.challenge,
            }
          },
        };
        let requestObject = {
          type: "normal",
          urlsInfo: requestUrl,
          data: {
            data: requestData,
          },
        };
        let messages = {
          title: "Challenge",
          loading: "Waiting for challenge update...",
          error: "Cannot get challenge update...",
        };
        let options = {
          loadingType: "fullscreen",
          timeout: TimeService.secondsToMillis(0),
        };
        APILoaderDecoratorService.setLoader(requestObject, messages, options)
            .then(responseSuccess => {
              if(this.challenge.published){
                this.searchStartupByChallenge();
              }
              this.navigate('*goBack*');
            });
      }
    },
    checkChallenge(){
      if(!this.$refs.form.validate()) return "errorForm";
      if(this.challenge.Title === "") return "errorTitle";
      if(this.challenge.Description === "") return "errorDescription";
      if(this.challenge.tags.length === 0) return "errorLenght";
      if(this.challenge.reward === "") return "errorReward";
      if(this.challenge.imgBase64 === values.placeholderImgBase64) return "errorImgBase64";
      if(this.challenge.date < new Date().toISOString().substring(0,10)) return "errorDate";

      return "noError"
    },
    checkDate(date){
      if(date < new Date().toISOString().substring(0,10)){
        this.snackbar = true
        this.snackbarText = "Deadline can't be placed in the past."
      } else{
        this.$refs.menu.save(date)
      }
    },

    getStartupToContactByChallenge() { //chiama api per ottenere la lista di startup in base ai tag
      console.log("getStartupTocontact: ",this.selectedMarket);
      let requestUrl = {
        url: UrlsService.getStartupToContactByChallenge,
        timeout: TimeService.secondsToMillis(0),
      };
      console.log("requestURL: ",requestUrl);
      let requestData = {
        interactionData: {
          challengeRequest: {
            challenge: {
              _id: this.challenge._id,
              Title: this.challenge.Title,
              Description: this.challenge.description,
              imgBase64: this.challenge.imgBase64,
              tags: this.challenge.tags,
              date: this.challenge.date,
              datePublished: this.challenge.datePublished,
              reward: this.challenge.reward,
              published: this.challenge.published,
              createdBy: this.challenge.createdBy,
              filterCountry: this.enableCountry ? this.selectedCountry : this.countries,
              filterMarket: this.enableMarket ? this.selectedMarket : this.markets,
              filterTech: this.enableTech ? this.selectedTech  : this.technologies,
            }
          }
        },
      };
      let requestObject = {
        type: "normal",
        urlsInfo: requestUrl,
        data: {
          data: requestData,
        },
      };
      let messages = {
        title: "Startup to contact Search",
        loading: "Waiting for startup search...",
        error: "Cannot search startup...",
      };
      let options = {
        loadingType: "silent",
        timeout: TimeService.secondsToMillis( 0),
      };
      APILoaderDecoratorService.setLoader(requestObject, messages, options)
          .then(responseSuccess => {
            console.log("responseSuccess: ",responseSuccess.response.startupsToContact);
            this.startupToContact = responseSuccess.response.startupsToContact;
            this.startupToContactRemoved = [];
          });
    },

    searchStartupByChallenge(){ //chiama l'api per inviare le email
      let requestUrl = {
        url: UrlsService.searchStartupByChallenge,
        timeout: TimeService.secondsToMillis(0),
      };
      let requestData = {
        interactionData: {
          startupToContactChallengeRequest: {
            idChallenge: this.challenge._id,
            nameChallenge: this.challenge.Title,
            startups: this.startupToContact,
            startupsRemoved: this.startupToContactRemoved,
          }
        },
      };
      let requestObject = {
        type: "normal",
        urlsInfo: requestUrl,
        data: {
          data: requestData,
        },
      };
      let messages = {
        title: "Startup Search",
        loading: "Waiting for startup search...",
        error: "Cannot search startup...",
      };
      let options = {
        loadingType: "silent",
        timeout: TimeService.secondsToMillis( 0),
      };
      APILoaderDecoratorService.setLoader(requestObject, messages, options)
          .then(responseSuccess => {
            console.log("response email: ", responseSuccess);
          });
    },
    imgUploaded(newValue){
      this.challenge.imgBase64 = newValue
    },
    textDescription(newValue){
      this.challenge.Description = newValue
    },
    getStartups(){
      let requestUrl = {
        url: UrlsService.getStartupsRegisteredToChallenge,
        timeout: TimeService.secondsToMillis(0),
      };
      let requestData = {
        interactionData: {
          challengeRequest: {
            challenge: {
              _id: this.challenge._id,
            }

          }
        },
      };
      let requestObject = {
        type: "normal",
        urlsInfo: requestUrl,
        data: {
          data: requestData,
        },
      };
      let messages = {
        title: "List Startups",
        loading: "Waiting for list of startups...",
        error: "Cannot get startups...",
      };
      let options = {
        loadingType: "silent",
        timeout: TimeService.secondsToMillis(0),
      };
      return APILoaderDecoratorService.setLoader(requestObject, messages, options)
          .then(responseSuccess => {
            this.startups = [];
            let responseStartups = responseSuccess.response.startups;
            for (let i = 0; i < responseStartups.length; i++) {
              this.startups.push({
                id: responseStartups[i]["_id"],
                name: responseStartups[i]["Name"],
                country: responseStartups[i]["Country"],
                contactName: responseStartups[i]["Contact name"],
                contactDetails: responseStartups[i]["Contact details"],
                market: responseStartups[i]["Addressed MU"],
                website: responseStartups[i]["Website"],

              });
            }
          });
    },
    downloadFile() {
      let requestUrl = {
        url: UrlsService.getFileStartupRegisteredToChallenge,
        timeout: TimeService.secondsToMillis(0),
      };
      let requestData = {
        interactionData: {
          challengeRequest: {
            challenge: {
              _id: this.challenge._id,
            }
          },
          startupRequest: {
            startup:{
              _id: this.selected.id,
            },
          }
        },
      };
      let requestObject = {
        type: "normal",
        urlsInfo: requestUrl,
        data: {
          data: requestData,
        },
      };
      let messages = {
        title: "Download Attachment",
        loading: "Waiting for attachment downloading...",
        error: "Cannot download attachment...",
      };
      let options = {
        loadingType: "fullscreen",
        timeout: TimeService.secondsToMillis(0),
      };
      APILoaderDecoratorService.setLoader(requestObject, messages, options)
          .then(responseSuccess => {
            let responseStartups = responseSuccess.response.file;

            const base64Sourvce = responseStartups;
            const downloadLink = document.createElement("a");
            const fileName = this.selected.name + "_attachment.pdf";

            downloadLink.href = base64Sourvce;
            downloadLink.download = fileName;
            document.body.appendChild(downloadLink);
            downloadLink.click();
          });
    },
  }

}
</script>

<style scoped>

.scrollable {
  max-height: 400px;
  overflow-y: auto;
}

.dialog {
  overflow-y: hidden;
}

.basic {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
}

.switch {
  width: 40%;
  padding-right: 5px;
  font-weight: bold;

}

.select {
  width: 60%;
}

</style>
